(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'GroupText',
	};

	var form_id = 'grouptext-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		Adzuki.TextSelection.initRecipients(form.name, 'travel_reminders');

		$('.insert-form-link').click(function clickFormLink(e)
		{
			var link    = $(this).data('url');
			var message = $('#' + form_id + 'message').val();

			e.preventDefault();

			$('#' + form_id + 'message').val(message + "\n" + link).trigger('input');
		});
	};
}(jQuery, window.Adzuki || {}));
